export default __webpack_public_path__ + "static/media/11-53.d87c8309.png";